import { getData, postData } from "./common.service";

export async function getInteractions(text: string = '', supportUserId: string, skip = 0) {
    const qs: any = {
        where: {
            and: [
                { supportUserId: supportUserId },
                { done: false },
                {
                    or:
                        [
                            { farmUserId: { like: `.*${text}.*`, options: 'i' } }
                        ]
                }
            ]
        },
        include: [{
            relation: 'farmUser',
            scope: {
                fields: ['farmUserId', 'name', 'mobile'],
            }
        },
        {
            relation: 'farm',
            scope: {
                fields: ['farmId', 'name'],
            }
        },
        {
            relation: 'plot',
            scope: {
                fields: ['plotId', 'name'],
            }
        }],
        order: 'created_date DESC',
        limit: 20,
        skip: skip
    };
    return getData('/interactions?filter=' + JSON.stringify(qs), {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    }).then(data => data.json())
}

export async function getInteraction(interactionId: string) {
    return getData(`/interactions/${interactionId}`, {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    }).then(data => data.json())
}

export async function getInteractionConfig() {
    return getData('/interactions/config', {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    }).then(data => data.json())
}

export async function addInteraction(data: any) {
    return postData('/interactions', {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: data
    })
}

export async function updateInteraction(interactionId: string, data: any) {
    return postData(`/interactions/${interactionId}`, {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: data,
        usePatchMethod: true
    })
}

export async function addConversation(interactionId: string, data: any) {
    return postData(`/interactions/${interactionId}/conversation`, {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: data
    })
}

export async function getPendingConversationsCount(supportUserId: string) {
    const qs: any = {
        where: {
            and: [
                { supportUserId: supportUserId },
                { done: false }
            ]
        }
    };
    return getData('/interactions/count?where=' + JSON.stringify(qs.where), {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    }).then(data => data.json())
}